import ContentLoader from "./ContentLoader";
import PageToolbar from "./PageToolbar";
import Pagination from "./Pagination";

type ListProps<TResult> = {
  title: string;
  createUpdate?: React.ReactNode;
  listData: React.ReactNode;
  searchForm?: React.ReactNode;
  isLoading: boolean;
  results: TResult[] | null;
  totalItems: number;
  pageSize: number;
  handlePageChange: (page: number, pageSize: number) => void;
  searchFormExist: boolean;
};

const CommonList = <TResult,>(props: ListProps<TResult>) => {
  const {
    title,
    listData,
    searchForm,
    isLoading,
    results,
    totalItems,
    pageSize,
    handlePageChange,
    createUpdate = null,
    searchFormExist,
  } = props || {};

  return (
    <>
      <div className="d-flex justify-content-between">
        {/*Page toolbar Area Start*/}
        <PageToolbar title={title} />
        {createUpdate ? createUpdate : null}
      </div>

      <div id="kt_content" className="content flex-column-fluid">
        {/*Search Area Start*/}
        {searchForm}
        {/*Search Area End*/}

        {/*Content Area Start*/}
        <div
          className={`card ${isLoading ? "overlay overlay-block" : ""}`}
          style={{
            minHeight: searchFormExist ? "70vh" : "75vh",
            maxHeight: searchFormExist ? "70vh" : "75vh",
          }}
          
        >
          <div className="card-body pt-0 pb-0 table-responsive">{listData}</div>
          {/*Content Area End*/}

          {/*Pagination Start*/}
          <div
            className={`sticky-bottom bg-white border rounded p-2 shadow-sm ${
              isLoading ? "" : "border-top"
            }`}
            style={{
              bottom: 0,
              zIndex: 2,
              // backgroundColor: `${isLoading ? "#BBBCBE" : "white"}`,
            }}
          >
            {results && results.length > 0 ? (
              <Pagination
                totalItems={totalItems}
                itemsPerPage={pageSize}
                onPageChange={handlePageChange}
              />
            ) : null}
          </div>
          {/*Pagination End*/}

          {/*Content Loader Start*/}
          {isLoading ? <ContentLoader /> : null}
          {/*Content Loader End*/}
        </div>
      </div>
    </>
  );
};

export default CommonList;
